import React, { useEffect, useState } from "react";

interface Props { }

export const AppVersion = (props: Props) => {
  const [version, setVersion] = useState("v.1.9.3");

  useEffect(() => {
    try {
      setVersion(process.env.APP_VERSION || "v.1.9.3");
    } catch { }
  }, []);

  return (
    <span style={{ position: "fixed", bottom: 20, right: 20 }}>
      {version}
    </span>
  );
};
